import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import FormHeader from "../common/FormHeader";
import { useRef } from "react";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function SiteRegisterList() {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const { userId } = useParams();
  const navigate = useNavigate();
  const [registers, setRegisters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(5);
  const searchInput = useRef();
  const [deletingId, setDeletingId] = useState(null);

  const fetchData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
      let res;
      if (userId) {
        res = await axios.get(`${baseUrl}/api/site-register/user/${userId}`, config);
      } else {
        res = await axios.get(`${baseUrl}/api/site-register`, config);
      }
      setRegisters(res.data.data || []);
    } catch {
      setRegisters([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [userId]);

  // Delete handler
  const handleDelete = async (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  // Edit handler (for demonstration, you can expand this to open a modal or navigate to edit page)
  const handleEdit = (id) => {
    const register = registers.find(r => r._id === id);
    if (!register) return toast.error("Register not found");
    setEditData({ ...register });
    setShowEditModal(true);
  };

  // Modal handlers
  const handleEditChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleEditSubmit = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
      await axios.put(`${baseUrl}/api/site-register/${editData._id}`, editData, config);
      toast.success("Site register updated successfully");
      setShowEditModal(false);
      setEditData(null);
      fetchData();
    } catch {
      toast.error("Failed to update site register");
    }
  };

  const handleDeleteConfirm = async () => {
    setDeletingId(deleteId);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
      await axios.delete(`${baseUrl}/api/site-register/${deleteId}`, config);
      toast.success("Site register deleted successfully");
      setShowDeleteModal(false);
      setDeleteId(null);
      fetchData();
    } catch {
      toast.error("Failed to delete site register");
    }
    setDeletingId(null);
  };

  // Filtered and paginated data
  const filtered = registers.filter(r => {
    const q = search.toLowerCase();
    return (
      r.first_name?.toLowerCase().includes(q) ||
      r.surname?.toLowerCase().includes(q) ||
      r.job_title_department?.toLowerCase().includes(q) ||
      r.site_location?.toLowerCase().includes(q) ||
      r.date?.toLowerCase().includes(q)
    );
  });
  const totalPages = Math.ceil(filtered.length / rowsPerPage);
  const paginated = filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      <FormHeader />
      <div className="container py-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 style={{ color: '#222', fontWeight: 700, letterSpacing: 1, fontSize: '1.6rem', margin: 0 }}>Site Register List</h2>
          <button
            className="btn btn-primary"
            style={{ background: '#8b1634', border: 'none', borderRadius: 8, fontWeight: 600, fontSize: '1rem', padding: '8px 22px', boxShadow: '0 2px 8px rgba(139,22,52,0.10)', transition: 'background 0.2s' }}
            onClick={() => navigate('/site-register')}
          >
            <i className="fa fa-plus me-2"></i> Add Register
          </button>
        </div>
        <div className="d-flex flex-wrap align-items-center mb-3" style={{ gap: 12, justifyContent: 'space-between' }}>
          <div className="d-flex align-items-center" style={{ gap: 8 }}>
            <input
              ref={searchInput}
              type="text"
              className="form-control"
              style={{ maxWidth: 260, borderRadius: 8, border: '1.5px solid #eaeaea', fontSize: '1rem', boxShadow: 'none' }}
              placeholder="Search by name, location, date..."
              value={search}
              onChange={e => { setSearch(e.target.value); setPage(1); }}
            />
          </div>
          <div style={{ fontSize: '0.98rem', color: '#888' }}>Total: <b>{filtered.length}</b></div>
        </div>
        <div className="card shadow-sm border-0" style={{ borderRadius: '16px', padding: '0', background: '#fff' }}>
          {loading ? (
            <div className="text-center py-5">Loading...</div>
          ) : (
            <div className="table-responsive">
              <table className="table mb-0" style={{ borderRadius: '12px', overflow: 'hidden', background: '#fff', fontSize: '1.01rem', boxShadow: '0 1px 6px rgba(139,22,52,0.06)' }}>
                <thead style={{ background: '#f3f6fa', color: '#8b1634', fontWeight: 700, fontSize: '1.07rem', borderBottom: '2px solid #eaeaea', letterSpacing: 0.2 }}>
                  <tr>
                    <th style={{ padding: '0.55rem 0.6rem', fontWeight: 700, fontSize: '1.04rem', letterSpacing: 0.5 }}>#</th>
                    <th style={{ padding: '0.55rem 0.6rem', fontWeight: 700, fontSize: '1.04rem', letterSpacing: 0.5 }}>USER</th>
                    <th style={{ padding: '0.55rem 0.6rem', fontWeight: 700 }}>DATE</th>
                    <th style={{ padding: '0.55rem 0.6rem', fontWeight: 700 }}>TIME IN</th>
                    <th style={{ padding: '0.55rem 0.6rem', fontWeight: 700 }}>TIME OUT</th>
                    <th style={{ padding: '0.55rem 0.6rem', fontWeight: 700 }}>LOCATION</th>
                    <th style={{ padding: '0.55rem 0.6rem', fontWeight: 700 }}>SIGNATURE</th>
                    <th style={{ padding: '0.55rem 0.6rem', fontWeight: 700, textAlign: 'center' }}>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {paginated.length === 0 ? (
                    <tr><td colSpan="8" className="text-center" style={{ padding: '1.2rem', color: '#888', fontSize: '0.95rem' }}>No records found.</td></tr>
                  ) : paginated.map((r, idx) => {
                    const initials = (r.first_name?.[0] || '') + (r.surname?.[0] || '');
                    return (
                      <tr key={r._id || idx} style={{ borderBottom: '1.5px solid #f3f6fa', transition: 'background 0.2s' }}
                        onMouseOver={e => e.currentTarget.style.background = '#f9f2f5'}
                        onMouseOut={e => e.currentTarget.style.background = ''}
                      >
                        <td style={{ textAlign: 'center', color: '#8b1634', fontWeight: 600, padding: '0.55rem 0.6rem' }}>{(page - 1) * rowsPerPage + idx + 1}</td>
                        <td style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '0.55rem 0.6rem' }}>
                          <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#e0e3e8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 17, color: '#7a7a7a', boxShadow: '0 2px 8px rgba(139,22,52,0.07)' }}>{initials.toUpperCase()}</div>
                          <div>
                            <div style={{ fontWeight: 600, color: '#222', fontSize: '1.01rem' }}>{r.first_name} {r.surname}</div>
                            <div style={{ color: '#888', fontSize: '0.93rem', marginTop: 2 }}>{r.job_title_department}</div>
                          </div>
                        </td>
                        <td style={{ padding: '0.55rem 0.6rem' }}>{r.date}</td>
                        <td style={{ padding: '0.55rem 0.6rem' }}>{r.time_in}</td>
                        <td style={{ padding: '0.55rem 0.6rem' }}>{r.time_out}</td>
                        <td style={{ padding: '0.55rem 0.6rem' }}>{r.site_location}</td>
                        <td style={{ padding: '0.55rem 0.6rem', textAlign: 'center' }}>
                          {r.signature ? (
                            <img src={r.signature} alt="Signature" style={{ width: 90, height: 38, objectFit: 'contain', border: '1.5px solid #eaeaea', borderRadius: 6, background: '#fff', boxShadow: '0 1px 6px rgba(139,22,52,0.07)' }} />
                          ) : (
                            <span style={{ color: '#bbb', fontSize: '1.1rem' }}>No sign</span>
                          )}
                        </td>
                        <td style={{ padding: '0.55rem 0.6rem', textAlign: 'center', minWidth: 100, display: 'flex', justifyContent: 'center', gap: 8 }}>
                          <button
                            className="btn p-0 me-2"
                            style={{ background: 'none', border: 'none', color: '#22c55e', fontSize: 20, transition: 'color 0.2s', verticalAlign: 'middle', borderRadius: '50%', padding: 5, boxShadow: '0 1px 6px rgba(34,197,94,0.08)' }}
                            title="Edit"
                            onClick={() => handleEdit(r._id)}
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                          <button
                            className="btn p-0"
                            style={{ background: 'none', border: 'none', color: '#e11d48', fontSize: 20, transition: 'color 0.2s', verticalAlign: 'middle', borderRadius: '50%', padding: 5, boxShadow: '0 1px 6px rgba(225,29,72,0.08)' }}
                            title="Delete"
                            onClick={() => handleDelete(r._id)}
                            disabled={deletingId === r._id}
                          >
                            <i className={deletingId === r._id ? "fa fa-spinner fa-spin" : "fa fa-trash"}></i>
                          </button>
                        </td>
      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>Edit Site Register</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editData && (
            <form>
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">First Name</label>
                  <input type="text" className="form-control" name="first_name" value={editData.first_name} onChange={handleEditChange} />
                </div>
                <div className="mb-3 col-md-6">
                  <label className="form-label">Surname</label>
                  <input type="text" className="form-control" name="surname" value={editData.surname} onChange={handleEditChange} />
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Job Title & Department</label>
                  <input type="text" className="form-control" name="job_title_department" value={editData.job_title_department} onChange={handleEditChange} />
                </div>
                <div className="mb-3 col-md-6">
                  <label className="form-label">Date</label>
                  <input type="date" className="form-control" name="date" value={editData.date} onChange={handleEditChange} />
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Time In</label>
                  <input type="time" className="form-control" name="time_in" value={editData.time_in} onChange={handleEditChange} />
                </div>
                <div className="mb-3 col-md-6">
                  <label className="form-label">Time Out</label>
                  <input type="time" className="form-control" name="time_out" value={editData.time_out} onChange={handleEditChange} />
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-md-12">
                  <label className="form-label">Site Location</label>
                  <input type="text" className="form-control" name="site_location" value={editData.site_location} onChange={handleEditChange} />
                </div>
              </div>
            </form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button style={{ background: '#8b1634', border: 'none', fontWeight: 600 }} onClick={handleEditSubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this site register?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm} disabled={deletingId === deleteId}>
            {deletingId === deleteId ? <i className="fa fa-spinner fa-spin"></i> : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center px-3 py-3" style={{ background: '#f7f8fa', borderTop: '1.5px solid #eaeaea', borderRadius: '0 0 16px 16px' }}>
            <div style={{ fontSize: '0.97rem', color: '#888' }}>Page {page} of {totalPages || 1}</div>
            <div className="d-flex align-items-center" style={{ gap: 4 }}>
              <button className="btn btn-sm" style={{ background: page === 1 ? '#eee' : '#8b1634', color: page === 1 ? '#aaa' : '#fff', border: 'none', borderRadius: 6, fontWeight: 600, minWidth: 32 }} disabled={page === 1} onClick={() => setPage(page - 1)}>&lt;</button>
              {[...Array(totalPages).keys()].map(i => (
                <button key={i} className="btn btn-sm" style={{ background: page === i + 1 ? '#8b1634' : '#fff', color: page === i + 1 ? '#fff' : '#8b1634', border: '1.5px solid #8b1634', borderRadius: 6, fontWeight: 600, minWidth: 32 }} onClick={() => setPage(i + 1)}>{i + 1}</button>
              ))}
              <button className="btn btn-sm" style={{ background: page === totalPages || totalPages === 0 ? '#eee' : '#8b1634', color: page === totalPages || totalPages === 0 ? '#aaa' : '#fff', border: 'none', borderRadius: 6, fontWeight: 600, minWidth: 32 }} disabled={page === totalPages || totalPages === 0} onClick={() => setPage(page + 1)}>&gt;</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SiteRegisterList;
